export default __webpack_public_path__ + "static/media/search.51235a43.svg";